import { initDialogs } from './dialog';
import { initTopParallax } from './parallax';
import { initVideos } from './video';
import { initQuestionPopup } from './question-popup';
export function initModules() {
    var modules = [].slice.apply(document.querySelectorAll('[data-ac-module]'))
        .filter(function (el) { return el.dataset.acModule; })
        .map(function (el) {
        return { el: el, name: el.dataset.acModule };
    }), triggers = [].slice.apply(document.querySelectorAll('[data-ac-action]'))
        .map(function (el) {
        var parts = el.dataset.acAction.match(/^([^.]+)\.?([^.]+)?$/);
        return parts && { el: el, module: parts[1], action: parts[2] };
    })
        .filter(function (o) { return o; });
    [
        initDialogs,
        initTopParallax,
        initVideos,
        initQuestionPopup,
    ].forEach(function (init) { return init(modules, triggers); });
}
